import axios from "axios";
import { API_BASE } from "../../config/env";
export const FETCH_EDITCAREPROVIDERDATA_FULFILLED = "FETCH_EDITCAREPROVIDERDATA_FULFILLED";
export const FETCH_EDITCAREPROVIDERDATA_REJECTED = "FETCH_EDITCAREPROVIDERDATA_REJECTED";
export const FETCH_EDITCAREPROVIDERDATA_PENDING = "FETCH_EDITCAREPROVIDERDATA_PENDING";
export const RESET_EDITCAREPROVIDERDATA = "RESET_EDITCAREPROVIDERDATA"

export function editCareProviderData(applicationId, careProviderData) {
    const token = localStorage.getItem("accessToken");

    return (dispatch) => {
        dispatch({
            type: "FETCH_EDITCAREPROVIDERDATA",
            payload: axios({
                method: "post",
                url: `${API_BASE}/api/v3/second-opinion/nurse-change-application-care-provider`,
                data : {applicationId,careProviderData},
                headers: {
                    "Authorization": "Bearer " + token,
                    "Accept-Language": "tr-tr",
                    "Client-Id": localStorage.getItem("One-Id"),
                    "One-Id": localStorage.getItem("Client-Id"),
                    "Content-Type": "application/json",
                    "ngrok-skip-browser-warning": "69920"
                },
            }).then((result) => result.data), 
        });
    };
}

export function resetEditCareProviderData() {
    return (dispatch) => {
        dispatch({
            type: "RESET_EDITCAREPROVIDERDATA",
        });
    };
}




